import {Controller, useFormContext} from "react-hook-form";
import {TreatmentHoldRequestReasonMap} from "../../domain";
import {SimpleDropdown} from "../../../../common";
import React from "react";
import {TreatmentHoldInput} from "./TreatmentHoldFormModal";

type ServiceTypeInputProps = {
    sending: boolean;
};

export function RequestReasonInput({sending}: ServiceTypeInputProps) {
    const {
        setValue,
        clearErrors,
        control,
    } = useFormContext<TreatmentHoldInput>();

    return (
        <div className="w-full text-black-200 pb-2 text-base items-center">
            <div className="flex items-center">
                <div className="w-2/6 text-right">
                    Request Reason
                </div>
                <div className="w-2/6 ml-4">
                    <Controller
                        name="requestReason"
                        control={control}
                        rules={{
                            required: "Please select 'Request Reason' before submitting",
                        }}
                        render={({field: {value}, fieldState: {error}}) => (
                            <>
                                <SimpleDropdown
                                    options={TreatmentHoldRequestReasonMap}
                                    selected={value}
                                    disabled={sending}
                                    hasErrorBorder={error !== undefined}
                                    setSelected={(selected) => {
                                        setValue("requestReason", selected);
                                        clearErrors("requestReason");
                                    }}
                                    textColor={"black-200"}
                                />
                                {error && <div className="text-red-700 mt-1">{error.message}</div>}
                            </>
                        )}/>
                </div>
            </div>
        </div>
    );
}
